import { createAction } from 'redux-actions';
import initialState from './initialState';
import formatActionTypeNames from '../helpers/formatActionTypeNames';

import { actions as appActions } from '../reducers/app.reducer';

export const actions = formatActionTypeNames(
	{
		getPopup: 'GET_POPUP',
		getPopupComplete: 'GET_POPUP_COMPLETE',
	},
	'POPUPS'
);

export const pagesActions = {
	getPopup: createAction(actions.getPopup),
	getPopupComplete: createAction(actions.getPopupComplete),
};

export default (state = initialState.pages, action) => {
	const { payload } = action;
	switch (action.type) {

		// case actions.getArticlesComplete:
		// 	return {
		// 		...state,
		// 		articles: {
		// 			...state.articles,
		// 			[`/${payload.page}`]: payload.response,
		// 		},
		// 	};

		case appActions.booted:
			return {
				...state,
				...payload.popups,
			};

		default:
			return state;
	}
};
